import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SLMap } from 'src/app/model/sl-map';
import { SLLayer } from 'src/app/model/sl-layer';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { AccessLevels } from 'src/app/types/access-levels';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';

@Component({
	selector: 'app-layer-select',
	templateUrl: './layer-select.component.html',
	styleUrls: ['./layer-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayerSelectComponent implements OnInit, OnDestroy {

	@Input() minAccessLevel = AccessLevels.READ;
	@Output() layerChange = new EventEmitter<SLLayer>();
	@ViewChild('layerSelect', { static: true }) layerSelect: ElementRef<HTMLSelectElement>;
	private _digitizerLayer = '';;
	@Input()
	set digitizerLayer(layerId) {
		if (this._digitizerLayer === layerId) {
			return;
		}
		this._digitizerLayer = layerId;
		if (layerId !== '') {
			this.layerChange.emit(this.map.GetLayerById(layerId));
		} else {
			this.layerChange.emit(null);
		}
	}
	get digitizerLayer(): string {
		return this._digitizerLayer;
	}
	@Input() readyHandler: AnyHandler;
	private _map: SLMap;
	@Input()
	set map(map: SLMap) {
		this.SetMap(map);
		// this.UpdateSelect();
	}
	get map(): SLMap {
		return this._map;
	}
	public layers: Array<SLLayer> = [];
	public buildingLayers = true;
	public waitingForLayers = false;
	private ready = false;
	private subscriptions = new SubScriptionMgr();
	constructor(private cdr: ChangeDetectorRef) { }

	SetMap(map) {
		if (this._map === map) {
			return;
		}
		if (!this.ready) {
			setTimeout(() => {
				this.SetMap(map);
			}, 20);
			return;
		}
		this._map = map;
		this.subscriptions.Subscribe(this._map.layerChange, () => {
			this.UpdateSelect();
		});
		if (this.waitingForLayers === true) { return; }
		this.UpdateSelect();
	}


	ngOnInit() {
		this.ready = true;
		if (!!this.map) {
			this.UpdateSelect();
		}

	}
Reset() {
    this.layerSelect.nativeElement.selectedIndex = 0;
    this.digitizerLayer = '';

  }
	SetLayer(layer: SLLayer): boolean {
		let changed = false;
		if (!!this.layers) {
			if (this.digitizerLayer !== layer.id) {
				this.digitizerLayer = layer.id;
				changed = true;
			}
			// this.UpdateSelect();
			this.layerSelect.nativeElement.selectedIndex = this.layers.indexOf(layer) + 1;
			if (changed) {
				this.DigitizerLayerChanged();
			}
		}
		return changed;
	}
	UpdateSelect() {
		if (!this.map && !this.map.layers) {
			window.requestAnimationFrame(() => {
				this.waitingForLayers = true;
				this.UpdateSelect();
			});
			return;
		}
		this.waitingForLayers = false;

		// $(this.layerSelect.nativeElement).children().remove();
		this.layers = [];
		this.buildingLayers = true;
		this.cdr.detectChanges();
		const layerIds = [];
		let i = -1;
		let selectedIndex = 0;
		for (const layer of this.map.layers) {
			if (layer.type >= 9000) {
				continue;
			}
			if (layer.hasSubLayers === true) { continue; }
			if (layer.access < this.minAccessLevel) { continue; }
			if (['point', 'line', 'polygon'].indexOf(layer.geom) < 0) { continue; }
			i += 1;
			if (layerIds.indexOf(layer.id) === -1) {
				this.layers.push(layer);
				layerIds.push(layer.id);


				if (layer.id === this.digitizerLayer) {
					selectedIndex = i;
				}
			}

		}
		this.buildingLayers = false;
		this.cdr.detectChanges();
		if (this._digitizerLayer === '') {
			this.layerSelect.nativeElement.selectedIndex = 0;
			this.cdr.detectChanges();

		}
		this.DigitizerLayerChanged();



	}
	DigitizerLayerChanged() {
		if ((this.map !== null) && (this._digitizerLayer !== '')) {
			const layer: SLLayer = this.map.GetLayerById(this.digitizerLayer);
			this.map.SetDigitizerLayer(layer);
			this.layerChange.emit(layer);
		}

	}
	ngOnDestroy() {
		this.subscriptions.CancelSubscriptions();
	}

}
